
import { Options, Vue } from 'vue-class-component';
import { Camera, GLTFResource, WebGLEngine, DirectLight, Color, Script, Entity, BackgroundMode, Animator, AmbientLight, AssetType, DiffuseMode, MeshRenderer } from "@galacean/engine";

@Options({
    mounted () {
      this.render()
    },
    methods: {
      render() {
        WebGLEngine.create({ canvas: "canvas", graphicDeviceOptions: { alpha: true }, }).then((engine) => {
          engine.canvas.resizeByClientSize();
          const scene = engine.sceneManager.activeScene;
          const { background } = scene;

          // 添加纯色背景
          background.mode = BackgroundMode.SolidColor; // 默认纯色背景
          background.solidColor.set(0, 0, 0, 0); // 纯白色

          const rootEntity = scene.createRootEntity();
          // const script = rootEntity.addComponent(TransformScript);

          const cameraEntity = rootEntity.createChild("camera");
          cameraEntity.addComponent(Camera);
          cameraEntity.transform.setPosition(0, 0.35, 2);

          const lightEntity = rootEntity.createChild("LightEntity");
          const directLight = lightEntity.addComponent(DirectLight);
          directLight.intensity = 0.7;
          lightEntity.transform.position.set(0, -2, 0);
          lightEntity.transform.setRotation(-45, 0, 0);
          // scene.ambientLight.diffuseMode = DiffuseMode.SolidColor;
          // scene.ambientLight.diffuseSolidColor.set(1, 1, 1, 1);
          scene.ambientLight.diffuseIntensity = 1;
          scene.ambientLight.specularIntensity = 1;

          engine.resourceManager
          .load<AmbientLight>({
            type: AssetType.Env,
            url: 'https://yunyingcdn.thecover.cn/o_1hkbjrj3e19r5rhu21d155m1umk17.env',
          })
          .then((ambientLight) => {
            scene.ambientLight = ambientLight;
          })

          engine.resourceManager
            .load<GLTFResource>(
            'https://yunyingcdn.thecover.cn/o_1hjrkj39e187r1ig01jok1vgqbi0e.glb'
            )
            .then((gltf) => {
              const obj = gltf.defaultSceneRoot;
              const materials = gltf.materials;
              materials?.forEach((item: any) => {
                // 设置材质的金属
                item.glossiness = 1;
              });
              const scale = 0.01;
              obj.transform.setScale(scale, scale, scale);
              // script.duck = obj;
              const animator: any = obj.getComponent(Animator);
              animator.speed = 0.5;
              animator.play("Take 001");
              rootEntity.addChild(obj);
            });

          engine.run();
        });
      },
    },
})
export default class Home extends Vue {}

/* class TransformScript extends Script {
  duck;
	onUpdate() {
    if (this.duck) {
      const nowTime = this.engine.time.actualElapsedTime;
      const rotateFactor = nowTime * 100;
      this.duck.transform.setRotation(0, rotateFactor, 0);
    }
  }
} */
